import styled from 'styled-components';

export const PillMainWrapper = styled.div<{ $position?: string }>`
    display: flex;
    justify-content: ${({ $position }) => $position || 'center'};
`;

export const PillStatusWrapper = styled.div<{ $isBuiltIn: boolean }>`
    display: flex;
    padding: 4px 8px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: var(--border-radius-round, 48px);
    width: fit-content;
    background: var(--colors-surface-primary, #fff);
    border: ${({ $isBuiltIn }) =>
        $isBuiltIn ? '1px solid var(--colors-text-success, #22A06B)' : '1px solid var(--colors-border-error, #DA1E28)'};
`;

export const PillTitleStatusWrapper = styled.div<{ $isBuiltIn: boolean }>`
    color: ${({ $isBuiltIn }) =>
        $isBuiltIn ? 'var(--colors-text-success, #22A06B)' : 'var(--colors-border-error, #DA1E28)'};
    font-family: var(--type-font-family, Poppins);
    font-size: 10px;
    font-weight: 500;
    line-height: var(--line-height-body-xs, 16px);
`;
